import { memo } from "react";

import ActionButton from "@/components/Button/ActionButton";

type RemoveButtonType = "collection" | "group" | "field";

/**
 * 削除ボタンコンポーネントのプロパティ
 */
interface RemoveButtonProps {
  /** コレクション/グループ/フィールドのインデックス  */
  index: number;

  /** 二次インデックス (グループの場合はグループインデックス) */
  secondaryIndex?: number;

  /** 削除ハンドラー */
  onRemove: (index: number, secondaryIndex?: number) => void;

  type: RemoveButtonType;

  className?: string;
}

/**
 * 削除ボタンコンポーネント
 * コレクション、グループ、フィールドなどの削除用UI
 */
export const RemoveButton = memo(
  ({ index, secondaryIndex, onRemove, type, className }: RemoveButtonProps) => {
    const handleClick = () => {
      onRemove(index, secondaryIndex);
    };

    return (
      <ActionButton
        variant="ghost"
        iconColor="primary"
        onClick={handleClick}
        aria-label={`${type}を削除`}
        icon="Trash2Icon"
        className={className}
      ></ActionButton>
    );
  },
);

RemoveButton.displayName = "RemoveButton";
